import { useQuery } from "@tanstack/react-query"
import TicketsAdminService from "services/admin/ticketsService"

export const useGetTickets = (queryParams: any = {}) => {
    return useQuery({
        queryKey: ['tickets', queryParams],
        queryFn: async () => {
            const response = await TicketsAdminService.getAllAndCount(queryParams)
            return response.data
        },
    })
}